import { render } from "./PopupLoadingEditor.vue?vue&type=template&id=1ec7f8af&scoped=true"
import script from "./PopupLoadingEditor.vue?vue&type=script&lang=js"
export * from "./PopupLoadingEditor.vue?vue&type=script&lang=js"

import "./PopupLoadingEditor.vue?vue&type=style&index=0&id=1ec7f8af&scoped=true&lang=css"

import exportComponent from "/Users/ions-alpha/Documents/IONS-project/pit-story/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ec7f8af"]])

export default __exports__